<template>
  <div class="bodys">
    <div
      class="bod"
      style="
        width: 1000px;
        margin: auto;
        backgroundcolor: #ffffff;
        padding: 20px 20px;
        margintop: 15px;
      "
    >
      <el-steps
        :space="1200"
        style="width: 1200px; marginleft: 27px; margin-top: 20px"
        :active="active"
      >
        <el-step title="阅读须知"></el-step>
        <el-step title="选择分组"></el-step>
        <el-step title="填写信息"></el-step>
        <el-step title="报名成功"></el-step>
      </el-steps>
      <!-- 步骤1内容 -->
      <div class="basicInfo" v-if="active === 0">
        <h2
          style="
            font-weight: 400;
            margin: 40px 0px;
            display: block;color:#000;
            text-align: center;
          "
        >
       2025 年江西省“振兴杯”工业互联网安全技术技能大赛
        </h2>
        <el-divider content-position="center">报名须知</el-divider>
        <div class="text-font">
          <p>
            <span>参赛选手需满足如下报名条件，请仔细阅读。</span
            ><span style="color: red">报名信息一旦录入将不支持线上修改。</span>
          </p>
          <p>01) 具有中华人民共和国国籍。</p>
          <p>02) 不得有违法犯罪记录。</p>
          <p>03) 思想品德优秀。</p>
          <p>04) 全省范围内的在职职工、教师，全日制在校学生。</p>
          <p>05) 思想品德优秀，学习能力较强，身体素质好。</p>
          <p>06) 具备较高的工业互联网安全技术技能水平。</p>
          <p style="text-indent: -2em;padding-left: 2em;"> 07) 已获得“中华技能大奖”“全国技术能手”称号及在2024年国家一级大赛获得前5名（双人赛项前3名、三人赛项前2名）、国家级二类大赛获得前3名（双人赛项前2名、三人赛项第1名），在2024年江西工业互联网安全技术技能大赛获得前2名且为职工（含教师）身份的人员，不得以选手身份参赛。具有全日制学籍的在校学生不得以职工身份参赛。
          </p>
          <p>
            08) 竞赛为三人团体赛，同一支队伍的报名参赛的角色分别为选手1（队长）、选手2、选手3，且同一自然人只能参加一支队伍。
          </p>
          <p>
            09) 每支队伍限一名领队，领队负责参赛队伍的组织、协调等相关工作，不参赛且不占用队伍名额。同一名领队可带领多支队伍。
          </p>
          <p>
            10) 填报的信息不得违反法律法规或有损社会公德，不得有侵害他人品牌、专利、商标等侵权行为。
          </p>
          <p>11) 报名起止时间：2025年10月20日-11月11日。</p>
          <span>
            <el-checkbox
              v-model="checked"
              @change="turf"
              text-color="#cccccc"
              style="margin: 20px 0px"
              >我已认真阅读“报名须知”且符合条件</el-checkbox
            ></span
          >
        </div>
        <div></div>
      </div>
      <!-- 步骤2内容 -->
      <div class="basicInfo" v-if="active === 1">
        <el-divider content-position="center">选择分组</el-divider>
        <el-row :gutter="12" style="margintop: 60px">
          <el-col :span="8" v-for="(item, index) in setData" :key="index">
            <div @click="nexts(index)">
              <el-card shadow="hover" class="cards">
                <p><img :src="item.img" alt="" width="15%" /></p>
                <p>{{ item.name }}</p>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- 步骤三内容 -->
      <div class="basicInfo" v-if="active === 2">
        <h1
          style="
            font-weight: 400;
            margin: 40px 0px;
            display: block;color:#000;
            text-align: center;
          "
        >
        2025 年江西省“振兴杯”工业互联网安全技术技能大赛
        </h1>
        <el-divider content-position="center">{{ names }}</el-divider>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-dynamic"
          style=" display: block; margin: auto"
        >
        <div class="content-col">
          <!-- 战队名称 -->
          <el-form-item label="战队名称" prop="buyerGroup" required>
            <el-input
              v-model="ruleForm.buyerGroup"
              @blur="onBlurGroup(ruleForm.buyerGroup)"
              placeholder="请输入战队名称"
            ></el-input>
          </el-form-item>
          <!-- 单位名称 -->
          <el-form-item
            label="单位名称"
            prop="buyerUnit"
            v-if="  names !== '学生组'"
            required
          >
            <el-input
              v-model="ruleForm.buyerUnit"
              placeholder="请输入单位名称"
            ></el-input>
          </el-form-item>
          <!-- 学校名称 -->
          <el-form-item
            label="学校名称"
            prop="buyerSchool"
            v-if="names !== '职工组/教师组' && names !== '线下挑战赛'"
            required
          >
            <el-input
              v-model="ruleForm.buyerSchool"
              placeholder="请输入学校名称"
            ></el-input>
          </el-form-item>
          <!-- 队伍城市 -->
          <el-form-item
            label="队伍城市"
            style="width: 400px"
            prop="checkCities"
            required
          >
            <el-cascader
              :options="optionss"
              v-model="ruleForm.checkCities"
              @change="handleChange"
              :separator="' '"
              clearable
            >
            </el-cascader>
          </el-form-item>
          </div>
          <!-- 表单 -->
          <el-divider content-position="left">领队</el-divider>
          <!-- —————————————————————————————————————————————————————————————————————————————— 领队 -->
          <div class="content-col">
          <!-- 姓名 -->
          <el-form-item label="姓名" prop="buyerName" required>
            <el-input
              v-model="ruleForm.buyerName"
              placeholder="请输入姓名,若无领队,填写队长信息"
            ></el-input>
          </el-form-item>
          <!-- 单位名称 -->
          <el-form-item
            label="单位名称"
            prop="buyerUnits"
            v-if="  names !== '学生组'"
            required
          >
            <el-input
              v-model="ruleForm.buyerUnits"
              placeholder="请输入单位名称"
            ></el-input>
          </el-form-item>
          <!-- 学校名称 -->
          <el-form-item
            label="学校名称"
            prop="buyerSchool"
            v-if="names !== '职工组/教师组' && names !== '线下挑战赛' "
            required
          >
            <el-input
              v-model="ruleForm.buyerSchools"
              placeholder="请输入学校名称"
            ></el-input>
          </el-form-item>
          <!-- 性别 -->
          <el-form-item label="性别" prop="buyerSex">
            <el-radio-group v-model="radio" @change="sex">
              <el-radio v-model="radios" :label="1">男</el-radio>
              <el-radio v-model="radios" :label="2">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 联系方式 -->
          <el-form-item label="联系电话" prop="buyerPhone" required>
            <el-input
              v-model="ruleForm.buyerPhone"
              @blur="onBlurTel(ruleForm.buyerPhone)"
              placeholder="请输入联系电话"
            ></el-input>
          </el-form-item>
          <!-- 身份证号 -->
          <el-form-item label="身份证" prop="buyerNume" required>
            <el-input v-model="ruleForm.buyerNume" @blur="onblurCid(ruleForm.buyerNume)" placeholder="请输入身份证" />
          </el-form-item>
          <!-- 邮箱 -->
          <el-form-item label="邮箱" prop="buyerEmail" required>
            <el-input
              v-model="ruleForm.buyerEmail"
              @blur="onBlurEmail(ruleForm.buyerEmail)"
              placeholder="请输入邮箱"
            ></el-input>
          </el-form-item>
          </div>
          <!-- ______________________________________________________________________ 选手1(队长) -->
          <el-divider content-position="left" class="xuanshou"
            >选手1(队长)</el-divider
          >
          <div class="content-col">
          <!-- 姓名 -->
          <el-form-item label="姓名" prop="buyerNames" required>
            <el-input
              v-model="ruleForm.buyerNames"
              placeholder="请输入姓名,若无领队,填写队长信息"
            ></el-input>
          </el-form-item>
          <!-- 单位名称 -->
          <el-form-item
            label="单位名称"
            prop="buyerUnitss"
            v-if="names !== '教师组' && names !== '学生组'"
            required
          >
            <el-input
              v-model="ruleForm.buyerUnitss"
              placeholder="请输入单位名称"
            ></el-input>
          </el-form-item>
          <!-- 学校名称 -->
          <el-form-item
            label="学校名称"
            prop="buyerSchool"
            v-if="names !== '职工组/教师组' && names !== '线下挑战赛'"
            required
          >
            <el-input
              v-model="ruleForm.buyerSchoolss"
              placeholder="请输入学校名称"
            ></el-input>
          </el-form-item>
          <!-- 性别 -->
          <el-form-item label="性别" prop="buyerSex1">
            <el-radio-group v-model="radios" @change="sexs">
              <el-radio v-model="radios" :label="1">男</el-radio>
              <el-radio v-model="radios" :label="2">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 联系方式 -->
          <el-form-item label="联系电话" prop="buyerPhones" required>
            <el-input
              v-model="ruleForm.buyerPhones"
              @blur="onBlurTel(ruleForm.buyerPhones)"
              placeholder="请输入联系电话"
            ></el-input>
          </el-form-item>
          <!-- 身份证号 -->
          <el-form-item label="身份证" prop="buyerNumes" required>
            <el-input
              v-model="ruleForm.buyerNumes"
              @blur="onblurCid(ruleForm.buyerNumes)"
              placeholder="请输入身份证"
            />
          </el-form-item>
          <!-- 邮箱 -->
          <el-form-item label="邮箱" prop="buyerEmails" required>
            <el-input
              v-model="ruleForm.buyerEmails"
              @blur="onBlurEmail(ruleForm.buyerEmails)"
              placeholder="请输入邮箱"
            ></el-input>
          </el-form-item>
          </div>
          <!-- _________________________________________________________________________ 选手2 -->
          <el-divider content-position="left" class="xuanshou"
            >选手2</el-divider
          >
          <div class="content-col">
          <!-- 姓名 -->
          <el-form-item label="姓名" prop="buyerNamess" required>
            <el-input
              v-model="ruleForm.buyerNamess"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
          <!-- 单位名称 -->
          <el-form-item
            label="单位名称"
            prop="buyerUnitsss"
            v-if="names !== '教师组' && names !== '学生组'"
            required
          >
            <el-input
              v-model="ruleForm.buyerUnitsss"
              placeholder="请输入单位名称"
            ></el-input>
          </el-form-item>
          <!-- 学校名称 -->
          <el-form-item
            label="学校名称"
            prop="buyerSchool"
            v-if="names !== '职工组/教师组' && names !== '线下挑战赛'"
            required
          >
            <el-input
              v-model="ruleForm.buyerSchoolsss"
              placeholder="请输入学校名称"
            ></el-input>
          </el-form-item>
          <!-- 性别 -->
          <el-form-item label="性别" prop="buyerSex2">
            <el-radio-group v-model="radioss" @change="sexss">
              <el-radio v-model="radios" :label="1">男</el-radio>
              <el-radio v-model="radios" :label="2">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 联系方式 -->
          <el-form-item label="联系电话" prop="buyerPhoness" required>
            <el-input
              v-model="ruleForm.buyerPhoness"
              @blur="onBlurTel(ruleForm.buyerPhoness, ruleForm.buyerPhone)"
              placeholder="请输入联系电话"
            ></el-input>
          </el-form-item>
          <!-- 身份证号 -->
          <el-form-item label="身份证" prop="buyerNumess" required>
            <el-input
              v-model="ruleForm.buyerNumess"
              @blur="onblurCid(ruleForm.buyerNumess,ruleForm.buyerNume)"
              placeholder="请输入身份证"
            />
          </el-form-item>
          <!-- 邮箱 -->
          <el-form-item label="邮箱" prop="buyerEmailss" required>
            <el-input
              v-model="ruleForm.buyerEmailss"
              @blur="onBlurEmail(ruleForm.buyerEmailss, ruleForm.buyerEmail)"
              placeholder="请输入邮箱"
            ></el-input>
          </el-form-item>
          </div>
          <!--  ——————————————————————————————————————————————————————————选手3 -->
          <el-divider content-position="left" class="xuanshou"
            >选手3</el-divider
          >
          <div class="content-col">
          <!-- 姓名 -->
          <el-form-item label="姓名" prop="buyerNamesss" required>
            <el-input
              v-model="ruleForm.buyerNamesss"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
          <!-- 单位名称 -->
          <el-form-item
            label="单位名称"
            prop="buyerUnitssss"
            v-if=" names !== '学生组'"
            required
          >
            <el-input
              v-model="ruleForm.buyerUnitssss"
              placeholder="请输入单位名称"
            ></el-input>
          </el-form-item>
          <!-- 学校名称 -->
          <el-form-item
            label="学校名称"
            prop="buyerSchool"
            v-if="names !== '职工组/教师组' && names !== '线下挑战赛' "
            required
          >
            <el-input
              v-model="ruleForm.buyerSchoolssss"
              placeholder="请输入学校名称"
            ></el-input>
          </el-form-item>
          <!-- 性别 -->
          <el-form-item label="性别" prop="buyerSex3">
            <el-radio-group v-model="radiosss" @change="sexsss">
              <el-radio v-model="radios" :label="1">男</el-radio>
              <el-radio v-model="radios" :label="2">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 联系方式 -->
          <el-form-item label="联系电话" prop="buyerPhonesss" required>
            <el-input
              v-model="ruleForm.buyerPhonesss"
              placeholder="请输入联系电话"
              @blur="onBlurTel(ruleForm.buyerPhonesss, ruleForm.buyerPhone)"
            ></el-input>
          </el-form-item>
          <!-- 身份证号 -->
          <el-form-item label="身份证" prop="buyerNumesss" required>
            <el-input
              v-model="ruleForm.buyerNumesss"
              @blur="onblurCid(ruleForm.buyerNumesss,ruleForm.buyerNume)"
              placeholder="请输入身份证"
            />
          </el-form-item>
          <!-- 邮箱 -->
          <el-form-item label="邮箱" prop="buyerEmailsss" required>
            <el-input
              v-model="ruleForm.buyerEmailsss"
              @blur="onBlurEmail(ruleForm.buyerEmailsss, ruleForm.buyerEmail)"
              placeholder="请输入邮箱"
            ></el-input>
          </el-form-item>
          </div>
        </el-form>
        <el-dialog
          title="提示"
          :visible.sync="centerDialogVisible"
          width="30%"
          center
        >
          <span>提交成功</span>
        </el-dialog>
        <div class="submit" style="display: block; textalign: center">
          <div>
            <el-checkbox v-model="checkeds" @change="turfs" text-color="#cccccc"
              >我已确认信息真实有效</el-checkbox
            >
          </div>
          <el-button
            type="primary"
            style="margin: 20px"
            :disabled="openDisableds"
            @click="Submit('ruleForm')"
            >提交</el-button
          >
        </div>
      </div>
      <!-- 步骤四内容 -->
      <div v-if="active === 3" class="forw">
        <div class="icon-wrap" id="icons">
          <i class="el-icon-circle-check"></i>
        </div>
        <div class="color-text-black">提交成功</div>
      </div>
      <!-- 下一步按钮 -->
      <el-button
        style="display: block; margin: auto"
        type="primary"
        @click="next"
        :disabled="openDisabled"
        v-if="active !== 1 && active !== 2 && active!==3 "
        >下一步</el-button
      >
    </div>
  </div>
</template>
<script>
import options from "../assets/country-level2-data";
import axios from "axios";
export default {
  data() {
    // 电话号码
    var checkPhone = (rule, value, callback) => {
      const phoneReg = /^1[3456789]\d{9}$$/;
      if (!value) {
        return callback(new Error("电话号码不能为空"));
      }
      setTimeout(() => {
        if (!Number.isInteger(+value)) {
          callback(new Error("请输入数字值"));
        } else {
          if (phoneReg.test(value)) {
            callback();
          } else {
            callback(new Error("电话号码格式不正确"));
          }
        }
      }, 100);
    };
    // 身份证
    var checkNume = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入身份证号"));
      } else {
        const reg =
          /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[0-2])(([0-2][1-9])|10|20|30|31)\d{3}(\d|X|x)$/;
        const card = reg.test(value);
        if (!card) {
          //判断座机为12位
          callback(new Error("身份证格式错误"));
        } else {
          callback();
        }
      }
    };
    // 邮箱
    var checkEmail = (rule, value, callback) => {
      const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
      if (!value) {
        return callback(new Error("邮箱不能为空"));
      }
      setTimeout(() => {
        if (mailReg.test(value)) {
          callback();
        } else {
          callback(new Error("请输入正确的邮箱格式"));
        }
      }, 100);
    };
    var checkName = (rule, value, callback) => {
      const nameReg = /^[\u4e00-\u9fa5]{2,}&/;
      if (!value) {
        return callback(new Error("输入不能为空"));
      } else {
        return callback(); // 一些同学的问题可能就出在这里
      }
    };
    var checkUnit = (rule, value, callback) => {
      const unitReg = /^[\u4e00-\u9fa5]{2,}&/;
      if (!value) {
        return callback(new Error("单位名称不能为空"));
      } else {
        return callback(); // 一些同学的问题可能就出在这里
      }
    };
    var checkSchool = (rule, value, callback) => {
      const unitReg = /^[\u4e00-\u9fa5]{2,}&/;
      if (!value) {
        return callback(new Error("学校名称不能为空"));
      } else {
        return callback();
      }
    };
    var checkSex = (rule, value, callback) => {
      if (value !== "" && this.radio) {
        callback();
      } else {
        callback(new Error("请选择性别"));
      }
    };
    var checkSex1 = (rule, value, callback) => {
      if (value !== "" && this.radios) {
        callback();
      } else {
        callback(new Error("请选择性别"));
      }
    };
    var checkSex2 = (rule, value, callback) => {
      if (value !== "" && this.radioss) {
        callback();
      } else {
        callback(new Error("请选择性别"));
      }
    };
    var checkSex3 = (rule, value, callback) => {
      if (value !== "" && this.radiosss) {
        callback();
      } else {
        callback(new Error("请选择性别"));
      }
    };
    return {
      apiUrl: localStorage.getItem("apiUrl"),
      radio: "",
      radios: "",
      radioss: "",
      radiosss: "",
      active: 0,
      required: true,
      checked: false,
      checkeds: false,
      openDisabled: true,
      openDisableds: true,
      centerDialogVisible:false,
      names: "",
      ruleForm: {
        checkCities: [],
      },
      rules: {
        // 领队
        buyerPhone: [
          { validator: checkPhone, required: true, trigger: "blur" },
        ],
        buyerNume: [{ validator: checkNume, trigger: "blur" }],
        buyerEmail: [{ validator: checkEmail, trigger: "blur" }],
        buyerName: [{ validator: checkName, trigger: "blur" }],
        buyerUnit: [{ validator: checkUnit, trigger: "blur" }],
        buyerGroup: [{ validator: checkName, trigger: "blur" }],
        buyerSchool: [{ validator: checkSchool, trigger: "blur" }],
        buyerSex: [{ validator: checkSex, trigger: "change" }],
        buyerSex1: [{ validator: checkSex1, trigger: "change" }],
        buyerSex2: [{ validator: checkSex2, trigger: "change" }],
        buyerSex3: [{ validator: checkSex3, trigger: "change" }],
        checkCities: [
          { required: true, message: "请选择城市", trigger: "change" },
        ],
        // 队长
        buyerNames: [{ validator: checkName, trigger: "blur" }],
        buyerPhones: [{ validator: checkPhone, trigger: "blur" }],
        buyerUnits: [{ validator: checkUnit, trigger: "blur" }],
        buyerNumes: [{ validator: checkNume, trigger: "blur" }],
        buyerEmails: [{ validator: checkEmail, trigger: "blur" }],
        buyerSchools: [{ validator: checkSchool, trigger: "blur" }],
        // 选手2
        buyerNamess: [{ validator: checkName, trigger: "blur" }],
        buyerPhoness: [{ validator: checkPhone, trigger: "blur" }],
        buyerUnitss: [{ validator: checkUnit, trigger: "blur" }],
        buyerNumess: [{ validator: checkNume, trigger: "blur" }],
        buyerEmailss: [{ validator: checkEmail, trigger: "blur" }],
        buyerSchoolss: [{ validator: checkSchool, trigger: "blur" }],
        // 选手3
        buyerNamesss: [{ validator: checkName, trigger: "blur" }],
        buyerPhonesss: [{ validator: checkPhone, trigger: "blur" }],
        buyerUnitsss: [{ validator: checkUnit, trigger: "blur" }],
        buyerUnitssss: [{ validator: checkUnit, trigger: "blur" }],
        buyerNumesss: [{ validator: checkNume, trigger: "blur" }],
        buyerEmailsss: [{ validator: checkEmail, trigger: "blur" }],
        buyerSchoolss: [{ validator: checkSchool, trigger: "blur" }],
      },
      setData: [
        {
          img: "https://www.chinaiisc.cn/static/register/img/zhi.d7285e3c.png",
          name: "职工组/教师组",
        },
           {
          img: "https://www.chinaiisc.cn/static/register/img/xue.6eba02c2.png",
          name: "学生组",
        },
        // {
        //   img: "https://www.chinaiisc.cn/static/register/img/lao.db20e169.png",
        //   name: "线下挑战赛",
        // },
     
      ],
      //存放默认值
      optionss: options, //存放城市数据
    };
  },

  methods: {
    //input框失去焦点触发检验身份证唯一性
    onblurCid(val,val1){
       if(val1){
           val1 == val ? this.$message.error("身份证号与队长的信息重复，请重填") : null;
           val="";
           return ;
         }
       axios.post(this.apiUrl+"/verifyIdCard",{
         identityCard: val
       }).then(res=>{
         console.log("cid",res);
        
           res.data.code === 1 ? this.$message.error(res.data.message) : null;
         res.data.code === 1 ? val="":null;
       })   
    },
    onBlurTel(tel,val1){
      console.log("key",String(tel));
      if(val1){
           val1 == tel ? this.$message.error("手机号与队长的信息重复，请重填") : null;
           tel = "";
           return ;
         }
      axios.post(this.apiUrl+"/verifyPhone",{
        Phone: tel
      }).then(res=>{
        console.log("tel",res);
        res.data.code === 1 ? this.$message.error(res.data.message) : null;
        res.data.code === 1 ? tel = "":null;
      })
    },
    onBlurEmail(val, val1){
      if(val1){
        val1 == val ? this.$message.error("邮箱与队长的信息重复，请重填"):null;
        val = "";
        return ;
      }
      axios.post(this.apiUrl+"/verifyEmail",{
        Email: val
      }).then(res=>{
        console.log("email",res);
        res.data.code === 1 ? this.$message.error(res.data.message) : null;
        res.data.code === 1 ? val = "":null;
      })
    },
    onBlurGroup(name){
      axios.post(this.apiUrl+"/verifyGroupName",{
        GroupName: name
      }).then(res=>{
        res.data.code === 1 ? this.$message.error(res.data.message) : null;
        res.data.code === 1? name = "":null;
      })
    },
    handleChange(value) {
      console.log(value);
    },
    turf() {
      if (this.checked == true) {
        this.openDisabled = false;
      } else {
        this.openDisabled = true;
      }
    },
    turfs() {
      if (this.checkeds == true) {
        this.openDisableds = false;
      } else {
        this.openDisableds = true;
      }
    },
    next() {
      if (this.active++ > 2) this.active = 0;
    },
    nexts(index) {
      this.names = this.setData[index].name;
      console.log(this.names);
      if (this.active++ > 2) this.active = 0;
    },
    sex(val) {
      if (val == 1) {
        this.ruleForm.buyerSex = "男";
      } else {
        this.ruleForm.buyerSex = "女";
      }
      console.log(val);
    },
    sexs(val) {
      if (val == 1) {
        this.ruleForm.buyerSexs = "男";
      } else {
        this.ruleForm.buyerSexs = "女";
      }
    },
    sexss(val) {
      if (val == 1) {
        this.ruleForm.buyerSexss = "男";
      } else {
        this.ruleForm.buyerSexss = "女";
      }
    },
    sexsss(val) {
      if (val == 1) {
        this.ruleForm.buyerSexsss = "男";
      } else {
        this.ruleForm.buyerSexsss = "女";
      }
    },
    // 提交
    Submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var me = this;
          var arr = me.ruleForm.checkCities;
          var buyercities = arr.join(",");
          
          var obj = { name: me.names, ...me.ruleForm, buyercities };
          axios
            .post(this.apiUrl+"/getData", {
              xinxi: obj,
            })
            .then((response) => {
              if (response.data.code == 1) {
                this.centerDialogVisible=true;
                if (this.active++ > 2) this.active = 0;
              }else if(response.data.code == 2){
                this.$message.error(response.data.message);
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style scoped>
p {
  font-size: 14px;
  color: #595959;
}
.bodys {
  background-color: #f0f2f5;
  width: 100%;
  padding: 50px 0;
  min-height: calc(100% - 80px - 212px);
}
.bod {
  width: 1000px;
  min-height: calc(100vh - 80px - 212px);
  margin: auto;
  background-color: #ffffff;
  padding: 20px 20px;
  margin-top: 15px;
}
.submit {
  display: block;
  text-align: center;
}
#icons {
  color: blue;
}
.icon-wrap {
  font-size: 100px;
}
.forw {
  display: block;
  text-align: center;
  margin: 50px 0px;
}
.cards {
  text-align: center;
}
.lingdui {
  font-size: 20px;
}
.xuanshou {
  font-size: 15px;
}
.text-font p{
  font-size: 16px;
  line-height: 26px;
}
.content-col{
  width: 620px;
  margin: 0 auto;
}
.color-text-black{color:#000;}
</style>